"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.array.splice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Control = _interopRequireDefault(require("../../elements/Control"));

var _mapToCssModules = _interopRequireDefault(require("../../utils/mapToCssModules"));

var _DefaultOption = _interopRequireDefault(require("./DefaultOption"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Description of the OptionGroup component
 */
var OptionGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(OptionGroup, _React$Component);

  var _super = _createSuper(OptionGroup);

  function OptionGroup(props) {
    var _this;

    _classCallCheck(this, OptionGroup);

    _this = _super.call(this, props);
    _this.handleOptionChange = _this.handleOptionChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OptionGroup, [{
    key: "handleOptionChange",
    value: function handleOptionChange(optValue) {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          type = _this$props.type;

      if (type === 'radio') {
        onChange(optValue);
      } else if (type === 'checkbox') {
        // Clone the array, we're going to mutate it.
        var valueClone = (value || []).slice();
        var optIndex = valueClone.indexOf(optValue);

        if (valueClone.indexOf(optValue) >= 0) {
          valueClone.splice(optIndex, 1);
        } else {
          valueClone.push(optValue);
        }

        onChange(valueClone);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          id = _this$props2.id,
          name = _this$props2.name,
          isInline = _this$props2.isInline,
          disabled = _this$props2.disabled,
          cssModule = _this$props2.cssModule,
          isHorizontal = _this$props2.isHorizontal,
          type = _this$props2.type,
          options = _this$props2.options,
          optionsClassName = _this$props2.optionsClassName,
          required = _this$props2.required,
          requiredText = _this$props2.requiredText,
          label = _this$props2.label,
          labelProps = _this$props2.labelProps,
          tooltip = _this$props2.tooltip,
          tooltipProps = _this$props2.tooltipProps,
          value = _this$props2.value,
          _onChange = _this$props2.onChange,
          helpText = _this$props2.helpText,
          error = _this$props2.error,
          status = _this$props2.status,
          statusMessage = _this$props2.statusMessage,
          renderOption = _this$props2.renderOption,
          attrs = _objectWithoutProperties(_this$props2, ["className", "id", "name", "isInline", "disabled", "cssModule", "isHorizontal", "type", "options", "optionsClassName", "required", "requiredText", "label", "labelProps", "tooltip", "tooltipProps", "value", "onChange", "helpText", "error", "status", "statusMessage", "renderOption"]);

      var _status = status;
      var _statusMessage = statusMessage;

      if (error) {
        _status = 'error';
        _statusMessage = error;
      }

      var inputClasses = (0, _mapToCssModules.default)((0, _classnames.default)(optionsClassName, 'options', {
        'is-horizontal': isHorizontal
      }), cssModule);
      var inputId = id || name;
      return /*#__PURE__*/_react.default.createElement(_Control.default, {
        className: className,
        tag: "fieldset",
        name: inputId,
        isInline: isInline,
        label: label,
        labelProps: labelProps,
        tooltip: tooltip,
        tooltipProps: tooltipProps,
        helpText: helpText,
        required: required,
        requiredText: requiredText,
        status: _status,
        statusMessage: _statusMessage
      }, /*#__PURE__*/_react.default.createElement("ul", _extends({
        className: inputClasses
      }, attrs), (options || []).map(function (option) {
        var checked = false;

        if (type === 'radio') {
          checked = value === option.value;
        }

        if (type === 'checkbox' && Array.isArray(value)) {
          checked = value.indexOf(option.value) >= 0;
        }

        return renderOption(_objectSpread(_objectSpread({}, option), {}, {
          id: "".concat(inputId, "__").concat(option.id),
          type: type,
          name: name,
          checked: checked,
          disabled: disabled,
          handleOptionChange: function handleOptionChange() {
            _this2.handleOptionChange(option.value);
          }
        }));
      })));
    }
  }]);

  return OptionGroup;
}(_react.default.Component);

OptionGroup.defaultProps = {
  className: undefined,
  isInline: false,
  id: undefined,
  cssModule: undefined,
  type: 'checkbox',
  isHorizontal: false,
  disabled: false,
  options: [],
  optionsClassName: undefined,
  required: false,
  requiredText: undefined,
  label: undefined,
  labelProps: {},
  tooltip: undefined,
  tooltipProps: {},
  helpText: undefined,
  value: undefined,
  onChange: function onChange() {},
  error: undefined,
  status: undefined,
  statusMessage: undefined,
  renderOption: _DefaultOption.default
};
OptionGroup.propTypes = {
  /**
   * A description of the prop, it will automatically appear in the docs
   */
  type: _propTypes.default.oneOf(['radio', 'checkbox']),
  className: _propTypes.default.string,

  /**
   * name will be used as the input's id if it's not provided.
   */
  id: _propTypes.default.string,

  /**
   * The name of the input, will also be used as the id.
   */
  name: _propTypes.default.string.isRequired,

  /**
   * Takes options of the form: { label: <string>, value: <any, ...extraProps }. Ignored if `children` are passed in.
   */
  options: _propTypes.default.array,

  /**
   * Any class(es) you want added the <ul> that wraps the options. For example, you could use this to add a '.fancy' class for styling.
   */
  optionsClassName: _propTypes.default.string,

  /**
   * The label of the control.
   */
  label: _propTypes.default.node,

  /**
   * Props to be passed to the label
   */
  labelProps: _propTypes.default.object,

  /**
   * The content of the controls tooltip.
   */
  tooltip: _propTypes.default.node,

  /**
   * Props to be passed to the tooltip
   */
  tooltipProps: _propTypes.default.object,

  /**
   * Help text to display below the field.
   */
  helpText: _propTypes.default.node,

  /**
   * If true, the control will use an inline layout. See `isHorizontal` to adjust the layout of the actual options.
   */
  isInline: _propTypes.default.bool,

  /**
   * If true, the options will be layed out horizontally. See `isInline` to adjust the layout of the controls label.
   */
  isHorizontal: _propTypes.default.bool,
  error: _propTypes.default.node,
  status: _propTypes.default.oneOf(['error', 'warning', 'info', 'success']),
  statusMessage: _propTypes.default.node,
  required: _propTypes.default.bool,
  requiredText: _propTypes.default.func,
  cssModule: _propTypes.default.object,
  onChange: _propTypes.default.func,

  /**
   * Expects a string/bool for radio buttons and an array of values for checkboxes
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool, _propTypes.default.array]),
  disabled: _propTypes.default.bool,

  /**
   * Render prop for option item
   */
  renderOption: _propTypes.default.func
};
var _default = OptionGroup;
exports.default = _default;
//# sourceMappingURL=OptionGroup.js.map